import Urls from 'Containers/Urls';
import {
  ADMIN_ACCOUNTS_RESULT, isExitResult,
} from 'Src/admin_money_accounts/flow/AdminAccounts.states';

export const ADMIN_ACCOUNTS_ROUTES = {
  ACCOUNT_DOMIC_SUBSCRIPTION_FORM: '/pay/cuentas-pago-automatico/agregar',
  ACCOUNT_FORM: '/pay/cuentas/agregar',
  ACCOUNT_REIMBURSEMENT_FORM: '/pay/cuentas-reembolso/agregar',
  CHECKOUT_FORM: '/pay/tarjetas/agregar',
  MANAGE_ACCOUNTS: '/pay/cuentas',
  MANAGE_CARDS: '/pay/tarjetas',
  MANAGE_DOMIC_SUBSCRIPTION_ACCOUNTS: '/pay/pago-automatico/cuentas',
  MANAGE_REIMBURSEMENT_ACCOUNTS: '/pay/cuentas-reembolso',
};
export const ADMIN_ACCOUNTS_RETURN_TO = {
  CONSUMER_PORTAL: '/pay/compras',
  DOMIC_SUBSCRIPTION: '/pay/pago-automatico',
  DOWNPAYMENT: '/pay/oferta',
  FUNNEL_4_ECOSYSTEM: '/pay/evaluacion/registro-tarjeta',
  PERSONAL_LOANS: '/pay/oferta',
  REIMBURSEMENT: '/pay/perfil/reembolso-automatico',
};

export const getNavigationRoute = (state) => {
  switch (state) {
    case ADMIN_ACCOUNTS_RESULT.IN_DOWNPAYMENT_APPLICATION:
      return ADMIN_ACCOUNTS_RETURN_TO.DOWNPAYMENT;
    case ADMIN_ACCOUNTS_RESULT.IN_FUNNEL_4_ECOSYSTEM:
      return ADMIN_ACCOUNTS_RETURN_TO.FUNNEL_4_ECOSYSTEM;
    case ADMIN_ACCOUNTS_RESULT.IN_PERSONAL_LOANS:
      // TODO: Add Funnel4Ecosystem url to listen callback
      return ADMIN_ACCOUNTS_RETURN_TO.PERSONAL_LOANS;
    case ADMIN_ACCOUNTS_RESULT.IN_CONSUMER_PORTAL:
      return ADMIN_ACCOUNTS_RETURN_TO.CONSUMER_PORTAL;
    case ADMIN_ACCOUNTS_RESULT.IN_MANAGE_CARDS:
      return ADMIN_ACCOUNTS_ROUTES.MANAGE_CARDS;
    case ADMIN_ACCOUNTS_RESULT.IN_CHECKOUT_FORM:
      return ADMIN_ACCOUNTS_ROUTES.CHECKOUT_FORM;
    case ADMIN_ACCOUNTS_RESULT.IN_MANAGE_ACCOUNTS:
      return ADMIN_ACCOUNTS_ROUTES.MANAGE_ACCOUNTS;
    case ADMIN_ACCOUNTS_RESULT.IN_ACCOUNT_FORM:
      return ADMIN_ACCOUNTS_ROUTES.ACCOUNT_FORM;
    case ADMIN_ACCOUNTS_RESULT.IN_REIMBURSEMENTS:
      return ADMIN_ACCOUNTS_RETURN_TO.REIMBURSEMENT;
    case ADMIN_ACCOUNTS_RESULT.IN_REIMBURSEMENTS_ACCOUNT_FORM:
      return ADMIN_ACCOUNTS_ROUTES.ACCOUNT_REIMBURSEMENT_FORM;
    case ADMIN_ACCOUNTS_RESULT.IN_MANAGE_REIMBURSEMENTS:
      return ADMIN_ACCOUNTS_ROUTES.MANAGE_REIMBURSEMENT_ACCOUNTS;
    case ADMIN_ACCOUNTS_RESULT.IN_DOMIC_SUBSCRIPTION_APPLICATION:
      return ADMIN_ACCOUNTS_RETURN_TO.DOMIC_SUBSCRIPTION;
    case ADMIN_ACCOUNTS_RESULT.IN_DOMIC_SUBSCRIPTION_FORM:
      return ADMIN_ACCOUNTS_ROUTES.ACCOUNT_DOMIC_SUBSCRIPTION_FORM;
    case ADMIN_ACCOUNTS_RESULT.IN_MANAGE_DOMIC_SUBSCRIPTION:
      return ADMIN_ACCOUNTS_ROUTES.MANAGE_DOMIC_SUBSCRIPTION_ACCOUNTS;
    default:
      // TODO: Test unhandled route case, define default route
      return Urls.movements;
  }
};

export const addAccountManagementParams = (url, data, result) => {
  let completeUrl = url;
  const params = new URLSearchParams();
  const {
    resources, from, state, event,
  } = data;

  if (resources?.card?.id) params.append('card_id', resources.card.id);
  if (from) params.append('from', from);
  if (state && !isExitResult(result)) params.append('state', state);
  if (event && !isExitResult(result)) params.append('event', event);

  const stringParams = params.toString();

  if (stringParams) completeUrl += `?${stringParams}`;

  return completeUrl;
};

// TODO: Refactor to handle multiple props in one param.
export const addParams = (url, resources, from, state, event) => {
  let completeUrl = url;
  const params = new URLSearchParams();

  if (resources?.card?.id) params.append('card_id', resources.card.id);
  if (from) params.append('from', from);
  if (state) params.append('state', state);
  if (event) params.append('event', event);

  const stringParams = params.toString();

  if (stringParams) completeUrl += `?${stringParams}`;

  return completeUrl;
};
